// extracted by mini-css-extract-plugin
module.exports = {"acceptTerms":"styles_acceptTerms__dSXiX"};